import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import CreateEditContent from './CreateEditContent';
import { Container, Main } from './styles';
import CustomBodyContent from './CustomBodyContent';
import { Colors } from '~/config/Colors';
import { SLEditModal, SLCreateModal } from '~/pages/Sistema/componentes/SistemaList';
import { useSelector } from 'react-redux';

export default function Comunicados() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState(null);
  const [selectedComunicado, setSelectedComunicado] = useState(null);
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check').then(response => setModulos(response.data));
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <div className="content">
        <Container
          requests={{
            findAll: () => api.get('/signed/empresa/gestorprojeto/comunicado'),
            findOne: thisData =>
              api.get('/signed/empresa/gestorprojeto/comunicado', {
                params: { id: thisData.id },
              }),
            deleteOne: thisData =>
              api.delete('/signed/empresa/gestorprojeto/comunicado', {
                data: { id: thisData.id },
              }),
          }}
          setter={setData}
          setLoaded={setLoadedData}
          loaded={loadedData}
          informationPage={{
            title: 'Comunicados',
            subTitle: 'Gerencie os Comunicados',
            icone: 'submenu-comunicado',
          }}
          tabFilter={{
            initial: { ativo: true },
            tabAtivo: 1,
            list: [
              {
                corDestaque: localStorage.getItem('tema') == 'E' ? '#9A3636' : '#e68282',
                corFundo: Colors?.Color8,
                title: 'Desativado',
                value: { ativo: false },
              },
              {
                corDestaque: Colors?.Color4,
                corFundo: Colors?.Color8,
                title: 'Ativo',
                value: { ativo: true },
              },
            ],
          }}
          inputs={[
            { filter: 'titulo', label: 'Título' },
            { filter: 'id', label: 'Id' },
          ]}
        >
          <SLEditModal
            title="Atualizar Comunicado"
            setter={setMountedData}
            customModal={false}
            defaultScroll={true}
          >
            {selectedComunicado && modulos && (
              <CreateEditContent {...{ modulos, mountedData: selectedComunicado, setLoadedData }} />
            )}
          </SLEditModal>

          <SLCreateModal title="Adicionar Comunicado" customModal={false} defaultScroll={true}>
            {modulos && <CreateEditContent {...{ modulos, setLoadedData }} />}
          </SLCreateModal>

          <CustomBodyContent
            setSelectedComunicado={setSelectedComunicado}
            {...{ data }}
            disableDefaultScroll={true}
          />
        </Container>
      </div>
    </Main>
  );
}
